import type { ICard } from "../cards/types";

export const drawCards = (
  source: ICard[],
  count: number
): ICard[] => {
  if (
    !Number.isInteger(count) ||
    count < 0
  ) {
    throw new Error(
      `Некорректное количество карт: ${count}`
    );
  }

  const sourceIds = new Set(
    source.map((card) => card.id)
  );

  if (sourceIds.size !== source.length) {
    throw new Error(
      "Невозможно выполнить draw: source содержит повторяющиеся card.id"
    );
  }

  if (count > source.length) {
    throw new Error(
      `Нельзя выбрать ${count} уникальных карт из ${source.length}`
    );
  }

  const shuffled = [...source];

  for (
    let index = shuffled.length - 1;
    index > 0;
    index -= 1
  ) {
    const randomIndex = Math.floor(
      Math.random() * (index + 1)
    );

    [
      shuffled[index],
      shuffled[randomIndex],
    ] = [
      shuffled[randomIndex],
      shuffled[index],
    ];
  }

  return shuffled.slice(0, count);
};